import { Calendar, calendarDetailed } from '@app/pcs/models/calendar';
import {gql} from 'apollo-angular';


export interface TrafficPeriod {
  id: number;
  calendar?: Calendar;
  periodInServiceCode?: string;
  designation?: string;
  ttpId?: number;
}

export const trafficPeriod = gql`
  fragment trafficPeriod on TrafficPeriod {
    id
    periodInServiceCode
    designation
  }
`;

export const trafficPeriodDetailed = gql`
    fragment trafficPeriodDetailed on TrafficPeriod {
        ...trafficPeriod
        calendar {
            ...calendarDetailed
        }
      ttpId
    }
    ${trafficPeriod}
    ${calendarDetailed}
`;
